import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import IStore from "../../models/IStore";
import RicercaPreventivoViewModel from "./models/RicercaPreventivoViewModel";
import PreventivoEffect from "./PreventivoEffect";
import PreventivoModel from "./models/PreventivoModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import PreventiviUtenteModel from "./models/PreventiviUtenteModel";
import PreventivoQuestionarioViewModel from "./models/PreventivoQuestionarioViewModel";
type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | RicercaPreventivoViewModel[]
    | PreventivoModel[]
    | PreventiviUtenteModel
    | ResponseEsitoModel
    | RicercaPreventivoViewModel;

export default class PreventivoAction {
    public static readonly REQUEST_PREVENTIVOS: string = "PreventivoAction.REQUEST_PREVENTIVOS";
    public static readonly REQUEST_PREVENTIVOS_FINISHED: string = "PreventivoAction.REQUEST_PREVENTIVOS_FINISHED";

    public static readonly SAVE_PREVENTIVOS: string = "PreventivoAction.SAVE_PREVENTIVOS";
    public static readonly SAVE_PREVENTIVOS_FINISHED: string = "PreventivoAction.SAVE_PREVENTIVOS_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_PREVENTIVOS: string = "PreventivoAction.REQUEST_SIMULAZIONE_PREVENTIVOS";
    public static readonly REQUEST_SIMULAZIONE_PREVENTIVOS_FINISHED: string =
        "PreventivoAction.REQUEST_SIMULAZIONE_PREVENTIVOS_FINISHED";

    public static readonly SET_FILTRI_RICERCA_PREVENTIVO: string = "PreventivoAction.SET_FILTRI_RICERCA_PREVENTIVO";
    public static readonly SET_FILTRI_RICERCA_PREVENTIVO_FINISHED: string =
        "PreventivoAction.SET_FILTRI_RICERCA_PREVENTIVO_FINISHED";

    public static readonly RESET_RISULTATI_RICERCA_PREVENTIVO: string =
        "PreventivoAction.RESET_RISULTATI_RICERCA_PREVENTIVO";
    public static readonly RESET_RISULTATI_RICERCA_PREVENTIVO_FINISHED: string =
        "PreventivoAction.RESET_RISULTATI_RICERCA_PREVENTIVO_FINISHED";

    public static readonly RESET_SIMULAZIONE_PREVENTIVO: string = "PreventivoAction.RESET_SIMULAZIONE_PREVENTIVO";
    public static readonly RESET_SIMULAZIONE_PREVENTIVO_FINISHED: string =
        "PreventivoAction.RESET_SIMULAZIONE_PREVENTIVO_FINISHED";

    public static readonly SET_FILTRI_QUESTIONARIO_RICERCA_PREVENTIVO: string =
        "PreventivoAction.SET_FILTRI_QUESTIONARIO_RICERCA_PREVENTIVO";
    public static readonly SET_FILTRI_QUESTIONARIO_RICERCA_PREVENTIVO_FINISHED: string =
        "PreventivoAction.SET_FILTRI_QUESTIONARIO_RICERCA_PREVENTIVO_FINISHED";

    public static readonly GET_FILTRI_RICERCA_PREVENTIVO: string = "PreventivoAction.GET_FILTRI_RICERCA_PREVENTIVO";
    public static readonly GET_FILTRI_RICERCA_PREVENTIVO_FINISHED: string =
        "PreventivoAction.GET_FILTRI_RICERCA_PREVENTIVO_FINISHED";

    public static readonly SET_REGISTRAZIONE_ANONIMA: string = "PreventivoAction.SET_REGISTRAZIONE_ANONIMA";
    public static readonly SET_REGISTRAZIONE_ANONIMA_FINISHED: string =
        "PreventivoAction.SET_REGISTRAZIONE_ANONIMA_FINISHED";

    public static readonly REQUEST_ERROR: string = "PreventivoAction.REQUEST_ERROR";
    public static readonly REQUEST_ERROR_FINISHED: string = "PreventivoAction.REQUEST_ERROR_FINISHED";

    public static requestSimulazionePreventivos(filtri: RicercaPreventivoViewModel): any {
        //       console.log("action filtri ", filtri);
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<PreventiviUtenteModel>(
                dispatch,
                PreventivoAction.REQUEST_SIMULAZIONE_PREVENTIVOS,
                PreventivoEffect.requestSimulazionePreventivos,
                filtri
            );
        };
    }

    public static requestPreventivos(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<PreventivoModel[]>(
                dispatch,
                PreventivoAction.REQUEST_PREVENTIVOS,
                PreventivoEffect.requestPreventivos
            );
        };
    }

    public static salvaPreventivo(preventivoSelezionato: PreventivoModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                PreventivoAction.SAVE_PREVENTIVOS,
                PreventivoEffect.savePreventivo,
                preventivoSelezionato
            );
        };
    }

    public static setFiltriRicercaPreventivo(ricercaPreventivo: RicercaPreventivoViewModel): any {
        return ActionUtility.createAction<RicercaPreventivoViewModel>(
            PreventivoAction.SET_FILTRI_RICERCA_PREVENTIVO_FINISHED,
            ricercaPreventivo
        );
    }

    public static resetRisultatiRicercaPreventivo(): any {
        return ActionUtility.createAction<any>(PreventivoAction.RESET_RISULTATI_RICERCA_PREVENTIVO_FINISHED);
    }

    public static resetPreventivoSimulazione(): any {
        return ActionUtility.createAction(PreventivoAction.RESET_SIMULAZIONE_PREVENTIVO_FINISHED);
    }

    public static setFiltriQuestionarioRicercaPreventivo(ricercaPreventivo: PreventivoQuestionarioViewModel): any {
        return ActionUtility.createAction<PreventivoQuestionarioViewModel>(
            PreventivoAction.SET_FILTRI_QUESTIONARIO_RICERCA_PREVENTIVO_FINISHED,
            ricercaPreventivo
        );
    }

    public static requestGetFiltri(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<RicercaPreventivoViewModel>(
                dispatch,
                PreventivoAction.GET_FILTRI_RICERCA_PREVENTIVO,
                PreventivoEffect.requestGetFiltri
            );
        };
    }

    public static setRegistrazioneAnonima(filtri: RicercaPreventivoViewModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<RicercaPreventivoViewModel>(
                dispatch,
                PreventivoAction.SET_REGISTRAZIONE_ANONIMA,
                PreventivoEffect.setRegistrazioneAnonima,
                filtri
            );
        };
    }

    public static requestError(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<any>(
                dispatch,
                PreventivoAction.REQUEST_ERROR,
                PreventivoAction.requestError
            );
        };
    }
}
